// Translation review (see "Translation review" in CLAUDE.md) shows the site's
// pages in frames of its app at /admin/translate/, with ?translation-review on
// their address. Such a page lists its nodes here, in document order and as
// its html made them: this is main.js's first import, so it runs before any
// other script of main.js can move, add or change a node. The bridge
// (bridge.ts, which vue-apps.js loads on such a page only) hands the list to
// the app, which finds in it the nodes of the segments it cut the html into.
//
// Anywhere else (any other page, or this one opened by itself or in another
// site's frame) it does nothing, and reviewFrame is false.
import { COMMENT_TOKEN, DOCTYPE_TOKEN, elementToken, textToken } from "../../../workers/translate/src/review/frames.ts";
import { REVIEW_APP, REVIEW_PARAM } from "./protocol.ts";

export interface Snapshot {
  nodes: Node[];
  tokens: string[];
}

declare global {
  interface Window {
    __translationReview?: Snapshot;
  }
}

function framedByReview(): boolean {
  try {
    if (!new URLSearchParams(location.search).has(REVIEW_PARAM)) return false;
    // frameElement is null unless the frame's parent is on this origin.
    return !!window.frameElement && window.parent.location.pathname.startsWith(REVIEW_APP);
  } catch {
    return false;
  }
}

// A node's token, made as annotate.ts makes it from the same html.
export function tokenOf(node: Node): string {
  if (node.nodeType === 1) {
    const element = node as Element;
    return elementToken(element.localName, element.getAttribute("id"), element.getAttribute("class"));
  }
  if (node.nodeType === 3) return textToken((node as Text).data);
  if (node.nodeType === 10) return DOCTYPE_TOKEN;
  return COMMENT_TOKEN;
}

export function snapshot(doc: Document): Snapshot {
  const nodes: Node[] = [];
  const tokens: string[] = [];
  const walk = (parent: Node) => {
    for (let child = parent.firstChild; child; child = child.nextSibling) {
      nodes.push(child);
      tokens.push(tokenOf(child));
      walk(child);
    }
  };
  walk(doc);
  return { nodes, tokens };
}

export const reviewFrame = framedByReview();
if (reviewFrame) window.__translationReview = snapshot(document);
